<template>
    <div>
        <van-sticky>
            <van-nav-bar title="支付结果" left-arrow @click-left="onClickLeft" />
        </van-sticky>
        <div>
            <div v-if="sts == 0">
                <div  class="pay-sts fail">支付失败</div>
                <div  class='tips'>
                    请在<span  class="warn">30分钟</span>内完成付款
                </div>
                <div class='tips'>否则订单会被系统取消</div>
                <div  class="btns">
                    <span  class='button checkorder' @click="getorderList(1)">查看订单</span>
                    <!-- <span class='button payagain'>重新支付</span> -->
                </div>
            </div>
            <div v-if="sts == 1">
                <div class="pay-sts succ">支付成功</div>
                <div class='tips'>感谢您的购买</div>
                <div  class="btns">
                    <span  class='button checkorder'  @click="getorderList(2)">查看订单</span>
                    <span  class='button shopcontinue'  @click="getHome">继续购物</span>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            orderNumbers:"",
            orderType:"",
            payType:1,
            sts:0,
        }
    },
    created(){
        this.orderNumbers = this.$route.query.orderNumbers;
        this.orderType = this.$route.query.orderType;
        this.payType = this.$route.query.payType;
        this.sts = this.$route.query.sts;
        console.log(this.orderNumbers,this.orderType,this.payType,this.sts,'this.sts');
    },
    methods:{
        onClickLeft() {
            this.$router.go(-1);
        },
        //跳转订单详情页
        getorderList(id){
            this.$router.push({path: '/orderList',query: { id: id }})
        },
        getHome(id){
            this.$router.push({path: '/'})
        },
    }
}
</script>
<style scoped>
.pay-sts.fail {
    color: #f43530;
}
.pay-sts {
    font-size: 20px;
    margin-top: 50px;
    padding: 15px 0;
    text-align: center;
}
.tips {
    font-size: 14px;
    color: #999;
    text-align: center;
}
.tips .warn {
    color: #f43530;
}
.btns {
    margin-top: 25px;
    text-align: center;
}
.btns .button.checkorder {
    background: #19be6b;
    color: #fff;
    margin-bottom: 20rpx;
    border: 1px solid #19be6b;
}
.btns .button {
    border-radius: 5px;
    font-size: 14px;
    background: #fff;
    color: #333;
    padding: 10px 12px;
    width: 150px;
    margin: 0 10px;
    text-align: center;
}
.btns .button.payagain {
    background: #fff;
    border: 1px solid #f90;
    color: #f90;
}
.btns .button {
    border-radius: 5px;
    font-size: 14px;
    background: #fff;
    color: #333;
    padding: 10px 12px;
    width: 150px;
    margin: 0 10px;
    text-align: center;
}
</style>